import { Auth } from 'aws-amplify'

export function isImpersonating() {
  return sessionStorage.getItem('impersonating') === 'true'
}

export async function canImpersonate() {
  try {
    const session = await Auth.currentSession()
    const groups =
      session?.getAccessToken?.()?.payload?.['cognito:groups'] || []

    const privilegedGroups = ['admin', 'broker', 'superbroker']
    const hasPrivilegedAccess = groups.some((g) =>
      privilegedGroups.includes(g.toLowerCase())
    )

    return hasPrivilegedAccess
  } catch (err) {
    console.error('[canImpersonate] Failed to evaluate groups:', err)
    return false
  }
}
